/**
 * ============================================================
 * KEJJA OS — WelcomeGate
 * If user has a home but no onboarded_at, send them to /welcome
 * so they see the intro once.
 * ============================================================
 */

import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from '@/hooks/useAuth';

export function WelcomeGate({ children }: { children: ReactNode }) {
  const { user } = useAuth();
  const loc = useLocation();

  // Always pass through for welcome + onboarding flows themselves
  if (loc.pathname === '/welcome' ||
      loc.pathname.startsWith('/onboarding') ||
      loc.pathname === '/verify-email') {
    return <>{children}</>;
  }

  // No user yet = AuthProvider or ProtectedRoute handles it
  if (!user) return <>{children}</>;

  // User has not completed welcome intro
  const raw = (user as unknown as { onboardedAt?: string | null; onboarded_at?: string | null });
  const onboardedAt = raw.onboardedAt ?? raw.onboarded_at;
  let localFlag = false;
  try { localFlag = sessionStorage.getItem(`kejja_welcomed_${user.id}`) === '1'; } catch { /* ignore */ }
  if (!onboardedAt && !localFlag) {
    return <Navigate to="/welcome" replace state={{ from: loc }} />;
  }
  return <>{children}</>;
}
